export const TIMEZONE = "Europe/Athens";

export const fmtNumber = (value, decimals = 2) => {
  const n = Number(value ?? 0);
  const [int, frac] = Math.abs(n).toFixed(decimals).split(".");
  const grouped = int.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return `${n < 0 ? "-" : ""}${grouped}${decimals ? `,${frac}` : ""}`;
};

export const fmtMoney = (value) => `${fmtNumber(value, 2)}\u00a0€`;

export const fmtInt = (value) => fmtNumber(value, 0);

export const fmtDate = (iso) => {
  if (!iso) return "—";
  const [y, m, d] = iso.slice(0, 10).split("-");
  return `${d}/${m}/${y}`;
};

export const fmtDateTime = (iso) =>
  new Intl.DateTimeFormat("el-GR", {
    timeZone: TIMEZONE, day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit",
  }).format(new Date(iso));

export const fmtWeekday = (iso, lang, style = "long") =>
  new Intl.DateTimeFormat(lang === "en" ? "en-GB" : "el-GR", { weekday: style, timeZone: "UTC" }).format(new Date(`${iso.slice(0, 10)}T12:00:00Z`));

export const fmtTime = (iso) =>
  new Intl.DateTimeFormat("el-GR", { timeZone: TIMEZONE, hour: "2-digit", minute: "2-digit", hour12: false }).format(new Date(iso));

export const vatOf = (net, rate) => Math.round(net * rate) / 100;

export const todayAthens = (offsetDays = 0) =>
  new Intl.DateTimeFormat("en-CA", { timeZone: TIMEZONE }).format(new Date(Date.now() + offsetDays * 86400000));
